import EventEmitter from './base/event-emitter';
import SSEConsumer from './sse-consumer';

export enum SSEEventName {
    SseTokenError = 'SSE_TOKEN_ERROR',
    SseOpen = 'SSE_OPEN',
}

class SSEEventsService extends EventEmitter {
    public emitSSETokenError(context : SSEConsumer, errorObject : any) {
        this.emit(SSEEventName.SseTokenError,context, errorObject);
    }

    public subscribeToSSETokenError = (
        callback: (...args: any[]) => any
    ) => {
        return this.subscribe(SSEEventName.SseTokenError, callback);
    };

    public emitSSEOpen() {
        this.emit(SSEEventName.SseOpen);
    }

    public subscribeToSSEOpen = (
        callback: (...args: any[]) => any
    ) => {
        return this.subscribe(SSEEventName.SseOpen, callback);
    };
}

export default new SSEEventsService();